(function(){
  var root = document.getElementById('wq-page');
  if(!root) return;
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Queens store constants ---------- */
  var QN_TEL = '+15163000944';
  var QN_TEL_DISPLAY = '(516) 300-0944';
  var EMAIL = 'info@wilsonebikes.com';
  var STORE_NAME = 'Queens Flagship (82-15 Queens Blvd, Elmhurst)';

  /* Eastern-time clock helper */
  function etParts(){
    try {
      var parts = new Intl.DateTimeFormat('en-US', {
        timeZone:'America/New_York', hour:'2-digit', minute:'2-digit', hour12:false, month:'numeric'
      }).formatToParts(new Date());
      var o = { hour:0, minute:0, month:7 };
      parts.forEach(function(p){
        if(p.type === 'hour') o.hour = parseInt(p.value, 10) % 24;
        if(p.type === 'minute') o.minute = parseInt(p.value, 10);
        if(p.type === 'month') o.month = parseInt(p.value, 10);
      });
      return o;
    } catch(e){
      var d = new Date();
      return { hour:d.getHours(), minute:d.getMinutes(), month:d.getMonth()+1 };
    }
  }
  function etDayName(){
    try {
      return new Intl.DateTimeFormat('en-US', { timeZone:'America/New_York', weekday:'long' }).format(new Date());
    } catch(e){
      var days = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
      return days[new Date().getDay()];
    }
  }
  function nyHoursForMonth(m){
    // Queens flagship hours: 10:30AM-7PM (ET), every day, year-round
    return { open:630, close:1140 }; // minutes
  }
  function nyHoursToday(){
    return nyHoursForMonth(etParts().month);
  }
  function fmt12(mins){
    var h = Math.floor(mins/60), mm = mins % 60;
    var ap = h >= 12 ? 'PM' : 'AM';
    var hh = h % 12; if(hh === 0) hh = 12;
    return hh + ':' + ('0'+mm).slice(-2) + ' ' + ap;
  }

  /* ---------- Booking flow (4 steps, Queens only) ---------- */
  var state = { ride:'', issue:'', date:'', dateLabel:'', time:'', store: STORE_NAME, tel: QN_TEL, telDisplay: QN_TEL_DISPLAY };
  var step = 1, TOTAL = 4;
  var panes = root.querySelectorAll('.wq-bp-pane');
  var crumbs = root.querySelectorAll('.wq-bp-crumb');
  var back  = document.getElementById('wq-back');
  var daysEl = document.getElementById('wq-bp-days');
  var timesEl = document.getElementById('wq-bp-times');
  var dayLabelEl = document.getElementById('wq-bp-daylabel');

  /* Running summary: fill a value into its chip */
  function setPass(key, val){
    var row = document.getElementById('wq-pass-' + key);
    if(!row) return;
    var v = row.querySelector('b');
    if(val){
      v.textContent = val;
      row.classList.add('wq-bp-row-set');
      if(!reduce){ v.classList.remove('wq-bp-stamp'); void v.offsetWidth; v.classList.add('wq-bp-stamp'); }
    } else {
      v.textContent = '\u2014';
      row.classList.remove('wq-bp-row-set');
    }
  }

  function show(n){
    step = n;
    panes.forEach(function(p){ p.hidden = (+p.dataset.pane !== n); });
    crumbs.forEach(function(c){
      var s = +c.dataset.step;
      c.classList.toggle('wq-bp-on', s === n);
      c.classList.toggle('wq-bp-done', s < n);
    });
    back.hidden = (n === 1);
    if(n === 3 && !state.date) initDateTimeStep();
    if(n === TOTAL) buildLinks();
  }
  crumbs.forEach(function(c){
    c.addEventListener('click', function(){
      var s = +c.dataset.step;
      if(s < step) show(s);
    });
  });

  function esc(s){ var t=document.createElement('span'); t.textContent=s||''; return t.innerHTML; }

  function buildLinks(){
    var nameEl = document.getElementById('wq-field-name');
    var phoneEl = document.getElementById('wq-field-phone');
    var descEl = document.getElementById('wq-field-desc');
    var emailEl = document.getElementById('wq-field-email');
    var modelEl = document.getElementById('wq-field-model');
    var name = nameEl ? nameEl.value.trim() : '';
    var phone = phoneEl ? phoneEl.value.trim() : '';
    var desc = descEl ? descEl.value.trim() : '';
    var slotTxt = (state.dateLabel && state.time) ? (state.dateLabel + ' \u00b7 ' + state.time + ' ET') : (window.__wqNextSlotText || '');

    setPass('name', name);

    var msg = 'Hi Wilson\u2019s Queens! I\u2019d like to book a repair at 82-15 Queens Blvd, Elmhurst.\n'
      + 'Ride: ' + state.ride + '\n'
      + 'Issue(s): ' + state.issue + '\n'
      + (slotTxt ? 'Requested slot: ' + slotTxt + '\n' : '')
      + 'My name: ' + (name || '____') + '\n'
      + 'My phone: ' + (phone || '____')
      + (desc ? '\nDetails: ' + desc : '');

    var ctaTextEl = document.getElementById('wq-cta-text');
    if(ctaTextEl){
      ctaTextEl.href = 'sms:' + QN_TEL + '?&body=' + encodeURIComponent(msg);
    }
    var ctaEmailEl = document.getElementById('wq-cta-email');
    if(ctaEmailEl){
      ctaEmailEl.href = 'mailto:' + EMAIL + '?subject=' + encodeURIComponent('Queens Repair Booking \u2014 ' + state.ride)
        + '&body=' + encodeURIComponent(msg);
    }
    var ctaCallEl = document.getElementById('wq-cta-call');
    if(ctaCallEl) ctaCallEl.href = 'tel:' + QN_TEL;
  }

  /* ---------- Confirm Booking: writes straight to the shop's Google Calendar ---------- */
  var BOOKING_ENDPOINT = "https://script.google.com/macros/s/AKfycby779T-3RrEgFYlNe6ERqyh9r67Ly4GFmeWLabXWf7-QRYV-6tZ3XPlsq_G7Z-rLV5Nsg/exec";
  var BOOKING_SHARED_SECRET = "7baa6fde45a3df7308c6ca288b3072da9b066182dcbc8370";

  function to24Hour(display){
    var m = /^(\d{1,2}):(\d{2})\s*(AM|PM)$/i.exec(display || '');
    if(!m) return '';
    var h = parseInt(m[1], 10);
    var min = m[2];
    var ampm = m[3].toUpperCase();
    if(ampm === 'PM' && h !== 12) h += 12;
    if(ampm === 'AM' && h === 12) h = 0;
    return (h < 10 ? '0' + h : h) + ':' + min;
  }

  function submitBookingToCalendar(){
    var btn = document.getElementById('wq-confirm-booking');
    var statusEl = document.getElementById('wq-confirm-status');
    if(!btn || !statusEl) return;

    if(!state.date || !state.time){
      statusEl.textContent = 'Pick a time slot above first.';
      statusEl.style.color = '#b45309';
      return;
    }

    var nameEl = document.getElementById('wq-field-name');
    var phoneEl = document.getElementById('wq-field-phone');
    var descEl = document.getElementById('wq-field-desc');
    var name = nameEl ? nameEl.value.trim() : '';
    var phone = phoneEl ? phoneEl.value.trim() : '';
    /* a booking with no number still lands; the shop can add one at the counter */
    if(phone && !/^\d{3}-\d{3}-\d{4}$/.test(phone)){
      statusEl.textContent = 'That phone number does not look right (xxx-xxx-xxxx) \u2014 fix it or leave it blank.';
      statusEl.style.color = '#b45309';
      phoneEl && phoneEl.focus();
      return;
    }

    var payload = {
      secret: BOOKING_SHARED_SECRET,
      shop: 'elmhurst',
      name: name,
      phone: phone,
      email: emailEl ? emailEl.value.trim() : '',
      model: modelEl ? modelEl.value.trim() : '',
      ride: state.ride || '',
      issue: state.issue || '',
      desc: descEl ? descEl.value.trim() : '',
      date: state.date,
      time: to24Hour(state.time),
    };

    btn.disabled = true;
    btn.textContent = 'Booking…';
    statusEl.textContent = '';

    // text/plain avoids a CORS preflight against the Apps Script endpoint.
    fetch(BOOKING_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify(payload),
    })
      .then(function(r){ return r.json(); })
      .then(function(result){
        if(result.ok){
          btn.textContent = 'Booked ✓';
          statusEl.textContent =
            'You’re on the schedule for ' + state.dateLabel + ' · ' + state.time + ' ET. See you at 82-15 Queens Blvd.';
          statusEl.style.color = '#108474';
        } else {
          throw new Error(result.error || 'Unknown error');
        }
      })
      .catch(function(){
        btn.disabled = false;
        btn.textContent = 'Confirm Booking';
        statusEl.textContent = 'Couldn’t reach the shop’s calendar — please call or text ' + QN_TEL_DISPLAY + ' instead.';
        statusEl.style.color = '#b91c1c';
      });
  }

  var confirmBookingBtn = document.getElementById('wq-confirm-booking');
  if(confirmBookingBtn) confirmBookingBtn.addEventListener('click', submitBookingToCalendar);

  root.addEventListener('input', function(e){
    var t = e.target;
    if(t && (t.id === 'wq-field-name' || t.id === 'wq-field-phone' || t.id === 'wq-field-desc')) buildLinks();
  });

  /* Phone field: digits only, auto-formatted as xxx-xxx-xxxx */
  var phoneFmtEl = document.getElementById('wq-field-phone');
  if(phoneFmtEl){
    phoneFmtEl.addEventListener('input', function(){
      var d = phoneFmtEl.value.replace(/\D/g, '').slice(0, 10);
      var out = d;
      if(d.length > 6) out = d.slice(0,3) + '-' + d.slice(3,6) + '-' + d.slice(6);
      else if(d.length > 3) out = d.slice(0,3) + '-' + d.slice(3);
      phoneFmtEl.value = out;
    });
  }

  /* Name & phone are required before sending booking via Text */
  function requireContactFields(e){
    var nEl = document.getElementById('wq-field-name');
    var pEl = document.getElementById('wq-field-phone');
  }
  var ctaTextGate = document.getElementById('wq-cta-text');
  if(ctaTextGate) ctaTextGate.addEventListener('click', requireContactFields);
  var ctaEmailGate = document.getElementById('wq-cta-email');
  if(ctaEmailGate) ctaEmailGate.addEventListener('click', requireContactFields);

  /* Ride: single select, auto-advance */
  root.querySelectorAll('.wq-bp-pill').forEach(function(btn){
    btn.addEventListener('click', function(){
      var f = btn.dataset.field;
      state[f] = btn.dataset.value;
      btn.parentElement.querySelectorAll('.wq-picked').forEach(function(b){ b.classList.remove('wq-picked'); });
      btn.classList.add('wq-picked');
      setPass(f, btn.dataset.short || btn.dataset.value);
      setTimeout(function(){ if(step < TOTAL) show(step+1); }, 200);
    });
  });

  /* Issues: multi-select toggles + Continue */
  state.issues = [];
  var issuesContinue = document.getElementById('wq-issues-continue');
  function syncIssues(){
    state.issue = state.issues.map(function(o){ return o.value; }).join(', ');
    var shorts = state.issues.map(function(o){ return o.short; });
    setPass('issue', shorts.length ? (shorts.length > 2 ? shorts.slice(0,2).join(' + ') + ' +' + (shorts.length-2) : shorts.join(' + ')) : '');
    if(issuesContinue) issuesContinue.disabled = state.issues.length === 0;
  }
  function syncContinueLabel(){ if(issuesContinue) issuesContinue.textContent = state.issues.length ? ('Continue with ' + state.issues.length + ' selected \u2192') : 'Continue \u2192'; }
  root.querySelectorAll('.wq-bp-issue').forEach(function(btn){ btn.addEventListener('click', function(){ setTimeout(syncContinueLabel, 0); }); });
  root.querySelectorAll('.wq-bp-issue').forEach(function(btn){
    btn.setAttribute('aria-pressed', 'false');
    btn.addEventListener('click', function(){
      var val = btn.dataset.value, sh = btn.dataset.short || val;
      var idx = state.issues.findIndex(function(o){ return o.value === val; });
      if(idx > -1){
        state.issues.splice(idx, 1);
        btn.classList.remove('wq-picked');
        btn.setAttribute('aria-pressed', 'false');
      } else {
        state.issues.push({ value: val, short: sh });
        btn.classList.add('wq-picked');
        btn.setAttribute('aria-pressed', 'true');
      }
      syncIssues();
    });
  });
  if(issuesContinue){
    issuesContinue.addEventListener('click', function(){
      if(state.issues.length && step < TOTAL) show(step+1);
    });
  }
  back.addEventListener('click', function(){ if(step > 1) show(step-1); });
  show(1);

  /* ---------- Time step: 14-day strip + scrollable 15-min slots, respects store hours ---------- */
  var MONTH_NAMES = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  var DOW_NAMES = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];

  function nyTodayParts(){
    try {
      var parts = new Intl.DateTimeFormat('en-US', {
        timeZone:'America/New_York', year:'numeric', month:'numeric', day:'numeric'
      }).formatToParts(new Date());
      var o = {};
      parts.forEach(function(p){
        if(p.type === 'year') o.year = parseInt(p.value, 10);
        if(p.type === 'month') o.month = parseInt(p.value, 10);
        if(p.type === 'day') o.day = parseInt(p.value, 10);
      });
      return o;
    } catch(e){
      var dd = new Date();
      return { year:dd.getFullYear(), month:dd.getMonth()+1, day:dd.getDate() };
    }
  }
  var todayNY = nyTodayParts();

  function dateKeyFor(y, m, dd){ return y + '-' + ('0'+m).slice(-2) + '-' + ('0'+dd).slice(-2); }
  function parseDateKey(key){
    var p = key.split('-').map(Number);
    return { y:p[0], m:p[1], d:p[2] };
  }
  function formatDateLabel(key){
    var p = parseDateKey(key);
    var dt = new Date(p.y, p.m - 1, p.d);
    return DOW_NAMES[dt.getDay()] + ', ' + MONTH_NAMES[p.m - 1].slice(0,3) + ' ' + p.d;
  }

  function buildTimeSlots(dateKey){
    var p = parseDateKey(dateKey);
    var h = nyHoursForMonth(p.m);
    var lastSlot = h.close - 60; // last bookable slot: 1 hour before close
    var isToday = (p.y === todayNY.year && p.m === todayNY.month && p.d === todayNY.day);
    var startMin;
    if(isToday){
      var et = etParts();
      var nowMins = et.hour * 60 + et.minute;
      startMin = Math.ceil((nowMins + 15) / 15) * 15; // next slot at least 15 min out, on the 15-min grid
      if(startMin < h.open) startMin = h.open;
    } else {
      startMin = h.open; // future day: first slot at opening
    }
    var slots = [];
    for(var t = startMin; t <= lastSlot; t += 15){ slots.push(t); }
    return slots;
  }

  function renderTimeSlots(){
    if(!timesEl) return;
    timesEl.innerHTML = '';
    if(dayLabelEl) dayLabelEl.textContent = '\u00b7 ' + state.dateLabel;
    var slots = buildTimeSlots(state.date);
    if(!slots.length){
      timesEl.innerHTML = '<p class="wq-bp-noslots">No more slots on ' + esc(state.dateLabel) + ' \u2014 pick another day, or just walk in and we\u2019ll fit you in.</p>';
      return;
    }
    slots.forEach(function(mins){
      var label = fmt12(mins);
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'wq-bp-time';
      b.textContent = label;
      b.addEventListener('click', function(){
        timesEl.querySelectorAll('.wq-bp-time').forEach(function(o){ o.classList.remove('wq-picked'); });
        b.classList.add('wq-picked');
        state.time = label;
        setPass('slot', state.dateLabel + ' \u00b7 ' + label);
        setTimeout(function(){ if(step < TOTAL) show(step + 1); }, 200);
      });
      timesEl.appendChild(b);
    });
  }

  function selectDate(key, btnEl){
    state.date = key;
    state.dateLabel = formatDateLabel(key);
    state.time = '';
    if(daysEl) daysEl.querySelectorAll('.wq-bp-day').forEach(function(b){ b.classList.remove('wq-picked'); });
    if(btnEl) btnEl.classList.add('wq-picked');
    renderTimeSlots();
  }

  function buildDayStrip(){
    if(!daysEl) return;
    daysEl.innerHTML = '';
    var base = new Date(todayNY.year, todayNY.month - 1, todayNY.day);
    for(var i = 0; i < 14; i++){
      var dt = new Date(base.getFullYear(), base.getMonth(), base.getDate() + i);
      var key = dateKeyFor(dt.getFullYear(), dt.getMonth() + 1, dt.getDate());
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'wq-bp-day';
      btn.dataset.value = key;
      btn.innerHTML = '<small>' + (i === 0 ? 'Today' : (i === 1 ? 'Tmrw' : DOW_NAMES[dt.getDay()])) + '</small><b>' + dt.getDate() + '</b><span>' + MONTH_NAMES[dt.getMonth()].slice(0,3) + '</span>';
      if(i === 0 && buildTimeSlots(key).length === 0) btn.disabled = true;
      btn.addEventListener('click', function(){
        if(this.disabled) return;
        selectDate(this.dataset.value, this);
      });
      daysEl.appendChild(btn);
    }
  }

  function initDateTimeStep(){
    buildDayStrip();
    var firstBtn = daysEl ? daysEl.querySelector('.wq-bp-day:not(:disabled)') : null;
    if(firstBtn) selectDate(firstBtn.dataset.value, firstBtn);
  }

  /* Location card "Book Repair Service" jumps to the ticket */
  var locBookBtn = document.getElementById('wq-loc-book-qn');
  if(locBookBtn){
    locBookBtn.addEventListener('click', function(){
      var bookSection = document.getElementById('book');
      var y = bookSection.getBoundingClientRect().top + window.pageYOffset - 64;
      window.scrollTo({ top:y, behavior: reduce ? 'auto' : 'smooth' });
      show(1);
    });
  }

  /* ---------- Why Wilson's — expanding panels ---------- */
  (function(){
    var wrap = document.getElementById('wq-why-x');
    if(!wrap) return;
    var panels = wrap.querySelectorAll('.wq-why-p');
    panels.forEach(function(p){
      p.addEventListener('click', function(){
        if(p.classList.contains('wq-why-open')) return;
        panels.forEach(function(o){
          o.classList.toggle('wq-why-open', o === p);
          o.setAttribute('aria-expanded', o === p ? 'true' : 'false');
        });
      });
    });
  })();

  /* ---------- Express bench interactive ---------- */
  (function(){
    var xpData = [
      { name:'Flat Tire Repair', tag:'Pothole and glass punctures, fixed while you wait.', price:'From $40', mins:20,
        icon:'https://cdn.shopify.com/s/files/1/0983/6625/9510/files/w1.png?v=1778773439',
        list:['Upfront starting price. Nothing starts until you approve the quote','New inner tube fitted, seated true, inflated to spec and spin-checked','A quick test ride outside the shop before you roll off'],
        note:'<b>Good to know:</b> Solid, tubed and tubeless setups in all common wheel sizes. The parts are on the shelf, so there\u2019s no waiting on an order.' },
      { name:'Tire & Tube Replacement', tag:'Fresh rubber for NYC streets, installed on the spot.', price:'From $65', mins:20,
        icon:'https://cdn.shopify.com/s/files/1/0983/6625/9510/files/w2.png?v=1778773444',
        list:['Street, off-road and no-flat options in stock for most brands','New tire and tube fitted, wheel and bearing cleaned and oiled, pressure-set for city riding','Old parts recycled, so you leave with nothing to throw away'],
        note:'<b>Good to know:</b> Ask about upgrading to no-flat tires. Many riders never patch a puncture again.' },
      { name:'Brake Repair', tag:'Confident, safe stopping for stop-and-go city miles.', price:'From $25', mins:15,
        icon:'https://cdn.shopify.com/s/files/1/0983/6625/9510/files/w3.png?v=1778773447',
        list:['Full brake check: pads, disc, clearance and bearings','Disc, drum and hydraulic service: adjustments, bleeds and replacements','Stop test at the store before your ride leaves the shop'],
        note:'<b>Good to know:</b> NYC stop-and-go traffic wears pads faster than you\u2019d think. Swing by any time we\u2019re open.' },
      { name:'Throttle Repair', tag:'Smooth, predictable acceleration, restored.', price:'From $50', mins:30,
        icon:'https://cdn.shopify.com/s/files/1/0983/6625/9510/files/w4.png?v=1778773434',
        list:['Throttle checked with the signal tested right at the connector','Repaired or replaced same day from in-stock parts','Acceleration verified on a test ride before hand-back'],
        note:'<b>Good to know:</b> Surging, lag or dead spots usually mean a throttle fault, not a motor problem. That\u2019s a cheaper fix than you feared.' },
      { name:'Lighting Repair', tag:'Headlights, taillights, LEDs and wiring, bright and legal.', price:'From $35', mins:30,
        icon:'https://cdn.shopify.com/s/files/1/0983/6625/9510/files/w5.png?v=1778773442',
        list:['Bulbs, LED strips, signals and full wiring harnesses serviced','Corroded connectors cleaned and sealed against NYC salt and rain','Full visibility check so you\u2019re street-legal after dark'],
        note:'<b>Good to know:</b> NYC requires a white front light and red rear light after dark. We\u2019ll make sure you pass.' },
      { name:'Error Code Fix', tag:'We read the code for free, find the fault and quote the fix.', price:'Read free · fix from $35', mins:5,
        icon:'https://cdn.shopify.com/s/files/1/0983/6625/9510/files/w6.png?v=1778773436',
        list:['Code read on the spot for any brand, free','Fault traced to the exact component, no guesswork','Upfront written quote with zero obligation to repair'],
        note:'<b>Good to know:</b> Reading the code is always free. Fixing the fault behind it starts at $35, and you approve the price before we start.' }
    ];
    var picks = root.querySelectorAll('.wq-xp-pick');
    var panel = document.getElementById('wq-xp-panel');
    if(!picks.length || !panel) return;
    var elIcon = document.getElementById('wq-xp-icon'),
        elName = document.getElementById('wq-xp-name'),
        elTag = document.getElementById('wq-xp-tag'),
        elPrice = document.getElementById('wq-xp-price'),
        elMins = document.getElementById('wq-xp-mins'),
        elList = document.getElementById('wq-xp-list'),
        elNote = document.getElementById('wq-xp-note'),
        elDial = document.getElementById('wq-xp-dial-fill');
    var CIRC = 232.5, MAX_MIN = 30;
    var checkSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6L9 17l-5-5"/></svg>';
    function setXp(i, focus){
      var d = xpData[i];
      picks.forEach(function(btn, j){
        var on = j === i;
        btn.setAttribute('aria-selected', on ? 'true' : 'false');
        btn.tabIndex = on ? 0 : -1;
        if(on && focus) btn.focus();
      });
      panel.setAttribute('aria-labelledby', 'wq-xp-tab-' + i);
      panel.classList.remove('wq-xp-swap');
      void panel.offsetWidth;
      panel.classList.add('wq-xp-swap');
      elIcon.src = d.icon; elIcon.alt = d.name + ' icon';
      elName.textContent = d.name;
      elTag.textContent = d.tag;
      elPrice.textContent = d.price;
      elMins.textContent = d.mins;
      elList.innerHTML = d.list.map(function(t){ return '<li>' + checkSvg + '<span>' + t + '</span></li>'; }).join('');
      elNote.innerHTML = d.note;
      var frac = Math.min(d.mins / MAX_MIN, 1);
      if(reduce){ elDial.style.transition = 'none'; }
      elDial.style.strokeDashoffset = (CIRC * (1 - frac)).toFixed(1);
    }
    picks.forEach(function(btn){
      btn.addEventListener('click', function(){ setXp(parseInt(btn.dataset.xp, 10), false); });
      btn.addEventListener('keydown', function(e){
        var i = parseInt(btn.dataset.xp, 10), n = picks.length;
        if(e.key === 'ArrowDown' || e.key === 'ArrowRight'){ e.preventDefault(); setXp((i + 1) % n, true); }
        if(e.key === 'ArrowUp' || e.key === 'ArrowLeft'){ e.preventDefault(); setXp((i - 1 + n) % n, true); }
        if(e.key === 'Home'){ e.preventDefault(); setXp(0, true); }
        if(e.key === 'End'){ e.preventDefault(); setXp(n - 1, true); }
      });
    });
    setXp(0, false);

    /* Mobile only: slow auto-scroll nudge so the row doesn't read as static —
       stops for good the instant the person touches or scrolls it themselves. */
    var xpList = document.getElementById('wq-xp-picklist');
    if(xpList && !reduce && matchMedia('(max-width:640px)').matches){
      var xpAuto = true, xpDir = 1, xpPauseUntil = 0;
      ['pointerdown','wheel','touchstart'].forEach(function(evt){
        xpList.addEventListener(evt, function(){ xpAuto = false; }, { passive:true });
      });
      function xpTick(ts){
        if(!xpAuto) return;
        var max = xpList.scrollWidth - xpList.clientWidth;
        if(max <= 4){ return; }
        if(ts >= xpPauseUntil){
          xpList.scrollLeft += 0.5 * xpDir;
          if(xpList.scrollLeft >= max - 1){ xpDir = -1; xpPauseUntil = ts + 1100; }
          else if(xpList.scrollLeft <= 1){ xpDir = 1; xpPauseUntil = ts + 1100; }
        }
        requestAnimationFrame(xpTick);
      }
      setTimeout(function(){ requestAnimationFrame(xpTick); }, 1000);
    }
  })();

  /* ---------- Smooth anchor scroll ---------- */
  root.querySelectorAll('a[href^="#"]').forEach(function(a){
    a.addEventListener('click', function(e){
      var id = a.getAttribute('href').slice(1);
      var el = document.getElementById(id);
      if(!el) return;
      e.preventDefault();
      var y = el.getBoundingClientRect().top + window.pageYOffset - 64;
      window.scrollTo({ top:y, behavior: reduce ? 'auto' : 'smooth' });
    });
  });

  /* ---------- Crew console (Meet the team) ---------- */
  (function(){
    var crew = root.querySelector('#wq-crew');
    if(!crew) return;
    var tabs = Array.prototype.slice.call(crew.querySelectorAll('.wq-crew-tab'));
    var panes = Array.prototype.slice.call(crew.querySelectorAll('.wq-crew-pane'));
    var idx = 0, timer = null, userTouched = false;

    function show(i){
      idx = (i + tabs.length) % tabs.length;
      tabs.forEach(function(t, n){
        var on = n === idx;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
        var prog = t.querySelector('.wq-crew-prog');
        if(prog){
          prog.classList.remove('wq-run');
          if(on && !userTouched && !reduce){ void prog.offsetWidth; prog.classList.add('wq-run'); }
        }
      });
      panes.forEach(function(p, n){
        var on = n === idx;
        p.hidden = !on;
        p.classList.remove('wq-on');
        if(on){ void p.offsetWidth; p.classList.add('wq-on'); }
      });
    }

    function stopAuto(){
      userTouched = true;
      if(timer){ clearInterval(timer); timer = null; }
      tabs.forEach(function(t){ var p = t.querySelector('.wq-crew-prog'); if(p) p.classList.remove('wq-run'); });
    }

    tabs.forEach(function(t, n){
      t.addEventListener('click', function(){ stopAuto(); show(n); });
      t.addEventListener('keydown', function(e){
        if(e.key === 'ArrowRight' || e.key === 'ArrowDown'){ e.preventDefault(); stopAuto(); show(idx + 1); tabs[idx].focus(); }
        if(e.key === 'ArrowLeft' || e.key === 'ArrowUp'){ e.preventDefault(); stopAuto(); show(idx - 1); tabs[idx].focus(); }
      });
    });

    /* Auto-rotate once the section is in view; stop forever on first tap */
    function startAuto(){
      if(reduce || userTouched || timer) return;
      /* No auto-rotation on touch devices: pane swaps mid-scroll caused layout
         shifts that made the page feel stuck around the gallery below. */
      if(matchMedia('(hover:none),(pointer:coarse)').matches) return;
      show(idx);
      timer = setInterval(function(){ if(!userTouched) show(idx + 1); }, 7000);
    }
    if('IntersectionObserver' in window){
      var cio = new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          if(en.isIntersecting){ startAuto(); }
          else if(timer){ clearInterval(timer); timer = null; tabs.forEach(function(t){ var p=t.querySelector('.wq-crew-prog'); if(p) p.classList.remove('wq-run'); }); }
        });
      },{ threshold:.35 });
      cio.observe(crew);
    } else { startAuto(); }

    show(0);
  })();

  /* ---------- Scroll-reveal ---------- */
  var revealTargets = root.querySelectorAll('.wq-xp-promise,.wq-xp-bench,.wq-svc-row,.wq-ride,.wq-station,.wq-proc-step,.wq-why-p,.wq-faq details,.wq-contact-card,.wq-xgal,.wq-live-card,.wq-final-opt,.wq-crew,.wq-perk-row,.wq-map-card,.wq-gmb-btn');
  if(!reduce && 'IntersectionObserver' in window){
    revealTargets.forEach(function(el,i){
      el.classList.add('wq-reveal');
      el.style.transitionDelay = (i % 4) * 70 + 'ms';
    });
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(en.isIntersecting){ en.target.classList.add('wq-in'); io.unobserve(en.target); }
      });
    },{ threshold:.12 });
    revealTargets.forEach(function(el){ io.observe(el); });
  }

  /* ---------- Stat count-up ---------- */
  var counters = root.querySelectorAll('.wq-count');
  function runCount(el){
    var target = parseFloat(el.dataset.target), suffix = el.dataset.suffix || '';
    var dec = parseInt(el.dataset.decimals || '0', 10);
    if(reduce){ el.textContent = target.toFixed(dec) + suffix; return; }
    var start = null, DUR = 1200;
    function tick(ts){
      if(!start) start = ts;
      var p = Math.min((ts - start) / DUR, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = (target * eased).toFixed(dec) + suffix;
      if(p < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }
  if('IntersectionObserver' in window){
    var cio = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(en.isIntersecting){ runCount(en.target); cio.unobserve(en.target); }
      });
    },{ threshold:.5 });
    counters.forEach(function(c){ cio.observe(c); });
  } else {
    counters.forEach(runCount);
  }

  /* ---------- Live Queens bench dashboard ---------- */
  var liveFinalEl = document.getElementById('wq-final-count');

  function isStoreOpenNow(){
    var h = nyHoursToday();
    var mins = etParts().hour * 60 + etParts().minute;
    return mins >= h.open && mins < h.close;
  }

  /* ---------- LIVE BENCH BOARD: ET clock + real, tappable slot timeline ---------- */
  var boardLiveEl   = document.getElementById('wq-board-live');
  var boardStatusEl = document.getElementById('wq-board-status');
  var railEl        = document.getElementById('wq-rail');
  var railLabelEl   = document.getElementById('wq-rail-label');
  var railPickedEl  = document.getElementById('wq-rail-picked');
  var railClaimEl   = document.getElementById('wq-rail-claim');
  var pickedSlot = null; // { label, dayWord }

  /* Real remaining bench slots: today's if any, otherwise tomorrow morning's */
  function computeRail(){
    var h = nyHoursToday();
    var p = etParts();
    var nowMins = p.hour * 60 + p.minute;
    var lastSlot = h.close - 60; // last bookable bench slot: 1 hour before close
    var open = nowMins >= h.open && nowMins < h.close;
    var isToday = true;
    var start;
    if(nowMins < h.open){
      start = h.open;
    } else {
      start = Math.ceil((nowMins + 15) / 15) * 15; // next slot at least 15 min out, on the grid
      if(start > lastSlot){ isToday = false; start = h.open; }
    }
    var slots = [];
    for(var t = start; t <= lastSlot; t += 15) slots.push(t);
    return { open:open, isToday:isToday, slots:slots, dayWord:(isToday ? 'Today' : 'Tomorrow'), openMins:h.open };
  }

  function applyPick(label, dayWord, announce){
    pickedSlot = { label:label, dayWord:dayWord };
    var full = dayWord + ' ' + label + ' ET';
    window.__wqNextSlotText = full; // booking ticket picks this up as the requested slot
    if(railPickedEl) railPickedEl.innerHTML = 'Your slot: <b>' + full + '</b>';
    if(railClaimEl) railClaimEl.textContent = 'Book ' + label + ' \u2192';
  }

  function renderRail(){
    if(!railEl) return;
    var r = computeRail();
    var keepLabel = pickedSlot && pickedSlot.label;
    railEl.innerHTML = '';
    if(railLabelEl) railLabelEl.textContent = r.isToday ? 'Today\u2019s open repair slots' : 'Repairs are done for today. Tomorrow\u2019s slots';
    if(boardStatusEl){
      boardStatusEl.textContent = r.open ? 'Open now. Walk-ins welcome' : 'Closed right now. Open daily 10:30 AM to 7 PM';
      boardStatusEl.classList.toggle('wq-board-status-neon', r.open);
      boardStatusEl.classList.toggle('wq-board-status-neon-red', !r.open);
      boardStatusEl.classList.toggle('wq-board-status-off', false);
    }
    if(boardLiveEl){
      boardLiveEl.classList.toggle('wq-board-live-off', !r.open);
      boardLiveEl.textContent = r.open
        ? 'Live from our Queens flagship, 82-15 Queens Blvd'
        : 'Our Queens flagship, 82-15 Queens Blvd';
    }

    var stillPicked = false;
    r.slots.forEach(function(mins, i){
      var label = fmt12(mins);
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'wq-chip' + (i === 0 ? ' wq-chip-next' : '');
      b.setAttribute('role', 'option');
      b.innerHTML = '<b>' + label + '</b><span>' + (i === 0 ? 'Next up \u00b7 ' + r.dayWord : r.dayWord) + '</span>';
      if(keepLabel === label){ b.classList.add('wq-chip-picked'); stillPicked = true; }
      b.addEventListener('click', function(){
        railEl.querySelectorAll('.wq-chip').forEach(function(c){ c.classList.remove('wq-chip-picked'); });
        b.classList.add('wq-chip-picked');
        applyPick(label, r.dayWord, true);
      });
      railEl.appendChild(b);
    });

    /* Default: highlight the next slot so the CTA and booking line always show a real time */
    if(!stillPicked && r.slots.length){
      applyPick(fmt12(r.slots[0]), r.dayWord, false);
      var first = railEl.querySelector('.wq-chip');
      if(first) first.classList.add('wq-chip-picked');
      pickedSlot = null; // soft default \u2014 refresh can advance it until the rider actively taps one
    } else if(!r.slots.length){
      if(railPickedEl) railPickedEl.textContent = 'No bookable slots right now \u2014 walk in, or text us and we\u2019ll fit you in.';
      if(railClaimEl) railClaimEl.textContent = 'Book a Repair';
    }
  }
  renderRail();
  setInterval(renderRail, 60 * 1000);

  /* ---------- LIVE WORKSHOP: 4-tech bench + live drop-off ticker ---------- */
  (function(){
    var listEl = document.getElementById('wq-ws-list');
    if(!listEl) return;
    var prenoteEl  = document.getElementById('wq-ws-prenote');
    var ondutyEl   = document.getElementById('wq-ws-onduty');
    var nextSlotEl = document.getElementById('wq-ws-nextslot');
    var tabToday   = document.getElementById('wq-ws-tab-today');
    var tabYday    = document.getElementById('wq-ws-tab-yday');
    var boardWxEl  = document.getElementById('wq-board-wx');

    /* Deterministic per-day randomness: the queue looks live but stays stable across refreshes */
    function seededRng(seed){
      /* mulberry32 — small, fast, well-mixed */
      var a = (seed >>> 0) || 1;
      return function(){
        a |= 0; a = (a + 0x6D2B79F5) | 0;
        var t = Math.imul(a ^ (a >>> 15), 1 | a);
        t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
      };
    }
    var dNow = new Date();
    var wsDayKey = dNow.getFullYear() * 372 + dNow.getMonth() * 31 + dNow.getDate();

    /* 6-day rotating cast: each day of the cycle draws from its own set of customers and
       rides, so a repeat visitor within the week never sees the same names/rides twice.
       On day 7 the cycle repeats — by then the "live board" has fully turned over anyway. */
    var wsNamePools = [
      ['Michael T.','Jessica R.','Brandon K.','Amanda L.','Tyler S.','Megan B.','Ryan C.','Ashley P.','Justin M.','Sarah D.','Kyle H.','Rachel N.'],
      ['Brian G.','Nicole A.','Jason V.','Emily Z.','Kevin O.','Stephanie J.','Eric Q.','Samantha U.','Andrew Y.','Chloe I.','Nathan E.','Olivia X.'],
      ['Anthony B.','Grace K.','Marcus J.','Sofia V.','Derek W.','Lauren F.','Trevor B.','Hannah K.','Corey P.','Vanessa M.','Douglas R.','Erica S.'],
      ['Jennifer W.','Christopher D.','Melissa H.','Patrick O.','Katie N.','Sean L.','Danielle F.','Gregory T.','Amber C.','Travis B.','Courtney J.','Shane V.'],
      ['Maria R.','Devon C.','Priya S.','Luis M.','Wei Z.','Fatima A.','Omar H.','Carlos G.','Amara O.','Danny W.','Mei L.','Aisha N.'],
      ['Jasmine T.','Pedro F.','Elena V.','Tariq S.','Ana C.','Junior D.','Isabella P.','Ethan G.','Noah K.','Ava R.','Mason D.','Zoe L.']
    ];
    /* Real models the Queens shop actually services — the exact catalog, spread evenly across all 6 rotating days */
    var wsRidePools = [
      ["Ausom DT2 Pro Electric Scooter","Punk Rider Pro Electric Scooter","Segway Xafari Electric Bike","Wilson's MX40 Electric Dirt Bike","NAVEE STORM X Pro Electric Dirt Bike","Teverun Blade GT II","Maxshot Electric Scooter","Segway Ninebot Max G3","Hiboy S2","isinwheel GT2","Segway Ninebot Max G2","Lectric XP 3.0","Aventon Abound","ESKUTE V100","AYOLNY Electric Bike","HappyRun G100 Pro","AZHAR Foldable Electric Bike"],
      ["Teverun Blade Mini Ultra Electric Scooter","Punk Rebel Electric Scooter","Segway Myon Electric Bike","NAVEE Storm G Electric Dirt Bike","APTUM AP-2C-1 Electric Dirt Bike","Segway ZT3 Pro","HopCycle Electric Scooter","Segway Ninebot E2 Pro","Hiboy KS4 Pro","isinwheel S10 Max","Inmotion Climber","Lectric XPedition 2.0","Ride1Up Prodigy V2","Heybike Cityscape 2.0","Tenways Wayfarer","ENGWE M20","URLIFE Foldable Electric Bike"],
      ["Teverun Fighter Mini Pro 2026 2.0 System","Nami Klima Electric Scooter","Hiboy EX6 Electric Bike","Yozma IN 10 Off-Road Electric Mini Dirt Bike","Teverun Fighter Supreme 7260R","Segway GT3 Pro","Aovowheel Electric Scooter","Segway Ninebot E3 Pro","Apollo Go","Kalorace Electric Scooter","TST Electric Bike","Aventon Aventure 3","Rad Power RadRunner 3 Plus","Heybike Villain","Tenways CGO600 Pro","Juiced Scrambler"],
      ["Teverun Blade Mini Pro Electric Scooter","Nami Klima Max Electric Scooter","Riding'times GT54 Electric Mini Motorbike","Yozma IN 10 Pro High-Performance Off-Road Electric Dirt Bike","Nami Super Stellar","KuKirin G2 Master","WERHY Electric Scooter","Segway Ninebot Kids eKickScooter","NAVEE UT5 Ultra X","EMOVE Cruiser V2","LELEKUAI Electric Bike","Aventon Aventure M","Rad Power RadWagon","Funhang Electric Bike","Tenways AGO X","Ariel Rider X-Class"],
      ["KuKirin G4 Electric Scooter","Segway MUXI Electric Bike","Riding'times GT73 Electric Motorbike","Wilson's MX37 Electric Dirt Bike","Teewing Z4 Pro","Teverun Fighter Supreme Ultra","Roinside Electric Scooter","Gotrax G4","isinwheel S9 Max","Levy Plus","Lectric XP4","Aventon Level 3","Rad Power RadRover","Jasion EB5","Velotric T1 ST Plus","RPINT Foldable Electric Bike"],
      ["Punk Rider Electric Scooter","Segway Xyber Electric Bike","Wilson's MX35 Electric Dirt Bike","NAVEE STORM X Electric Dirt Bike","Teverun Fighter Eleven+","VOLPAM Electric Scooter","NAVIC Electric Scooter","TurboAnt M10 Pro","isinwheel S9 Pro","Apollo City Pro","Lectric XP LITE 2.0","Aventon Pace 4","Yozma IN10 Electric Dirt Bike","Qlife Racer","Himiway Electric Bike","DTTZH Foldable Electric Bike"]
    ];
    function wsCycle(dayKey){ return ((dayKey % 6) + 6) % 6; }
    /* Mostly quick express services */
    var wsJobs = [
      { t:'Flat tire repair',        min:20 },
      { t:'Flat tire repair',        min:20 },
      { t:'Tire & tube replacement', min:20 },
      { t:'Tube replacement',        min:15 },
      { t:'Brake repair',            min:15 },
      { t:'Brake adjustment',        min:15 },
      { t:'Brake pad swap',          min:15 },
      { t:'Throttle repair',         min:30 },
      { t:'Lighting repair',         min:30 },
      { t:'Error-code diagnosis',    min:5  },
      { t:'Battery diagnosis',       min:10 },
      { t:'Charger port fix',        min:25 },
      { t:'Fender & bolt tighten',   min:10 },
      { t:'Quick tune-up',           min:30 }
    ];
    var wsStages = ['Diagnosing\u2026','Pulling parts\u2026','Replacing part\u2026','Reassembling\u2026','Final testing\u2026'];
    var wsAvColors = ['#3B5C54','#1D5FA8','#8A5A9E','#B85C2E','#2B7A78','#A8322F','#4C6B2F','#375A7F'];
    var storeOpenNow = isStoreOpenNow();

    function wsPick(rand, arr){ return arr[Math.floor(rand() * arr.length)]; }

    /* Build a day's drop-off queue from a seed. Entries "arrive" spaced through store hours. */
    function buildDayQueue(dayKey, hours, maxCount){
      var rand = seededRng(dayKey * 7 + 13);
      var pool = wsCycle(dayKey);
      var names = wsNamePools[pool].slice();
      var rides = wsRidePools[pool].slice();
      var span = hours.close - 60 - hours.open;
      var q = [];
      for(var i = 0; i < maxCount; i++){
        var ni = Math.floor(rand() * names.length);
        var ri = Math.floor(rand() * rides.length);
        q.push({
          name: names.splice(ni, 1)[0] || wsPick(rand, wsNamePools[pool]),
          ride: rides.splice(ri, 1)[0] || wsPick(rand, wsRidePools[pool]),
          job:  wsPick(rand, wsJobs).t,
          drop: hours.open + Math.floor((i / maxCount) * span + rand() * (span / maxCount)),
          color: wsAvColors[(dayKey + i) % wsAvColors.length]
        });
      }
      return q;
    }

    /* Live day: the shop cycles through the whole flow, checked-in to checked-out */
    function statusFor(age, seedVal){
      if(age < 6)   return { cls:'wq-ws-badge-in',    txt:'Checked in' };
      if(age < 16)  return { cls:'wq-ws-badge-diag',  txt:'Diagnosing' };
      if(age < 42)  return { cls:'wq-ws-badge-prog',  txt:'Being repaired' };
      if(age < 52)  return { cls:'wq-ws-badge-test',  txt:'Test riding' };
      /* finished rides: some still on the rack, some already collected */
      return seededRng(seedVal * 31 + 7)() < 0.55
        ? { cls:'wq-ws-badge-ready', txt:'Ready for pickup' }
        : { cls:'wq-ws-badge-out',   txt:'Checked out' };
    }
    function timeLabel(age, dropMins){
      if(age < 3)  return 'just now';
      if(age < 60) return age + ' min ago';
      return 'dropped off ' + fmt12(dropMins);
    }

    /* Each status maps to a spot on the repair journey — drawn as a mini progress line per row */
    var wsPct = { 'Checked in':12, 'Diagnosing':32, 'Being repaired':58, 'Test riding':78, 'Ready for pickup':92, 'Checked out':100, 'Picked up':100, 'Awaiting pickup':92 };
    function rowHtml(e, badge, when){
      var pct = wsPct[badge.txt] || 50;
      return '<div class="wq-ws-row">'
        + '<span class="wq-ws-row-txt"><b>' + e.ride + ' \u2014 ' + e.job + '</b><small>' + e.name + ' \u00b7 ' + when + '</small></span>'
        + '<span class="wq-ws-badge ' + badge.cls + '"><i aria-hidden="true"></i>' + badge.txt + '</span>'
        + '<span class="wq-ws-rowbar" aria-hidden="true"><i style="width:' + pct + '%"></i></span>'
        + '</div>';
    }

    var wsTab = 'today';
    function renderQueue(){
      var p = etParts();
      var nowMins = p.hour * 60 + p.minute;
      var hToday = nyHoursToday();
      var closed = nowMins >= hToday.close;
      var preOpen = nowMins < hToday.open;
      var rows = [];
      var counts = {};
      function pushRow(e, badge, when){ counts[badge.txt] = (counts[badge.txt] || 0) + 1; rows.push(rowHtml(e, badge, when)); }

      /* notes only ever show during the pre-open warehouse view — reset by default every render */
      if(prenoteEl)  prenoteEl.hidden  = true;

      if(wsTab === 'yesterday'){
        var yRand = seededRng(wsDayKey * 11 + 5);
        buildDayQueue(wsDayKey - 1, hToday, 10).forEach(function(e){
          var picked = yRand() < 0.7;
          pushRow(e,
            picked ? { cls:'wq-ws-badge-done', txt:'Picked up' } : { cls:'wq-ws-badge-ready', txt:'Awaiting pickup' },
            'done ' + fmt12(Math.min(hToday.close - 30, e.drop + 45)));
        });
      } else if(preOpen){
        /* not open yet today — no live drop-offs, but show real warehouse activity instead of nothing */
        var whProducts = [
          'Segway GT3 Pro', 'Navee ST3 Pro', 'Teverun Fighter Mini Pro',
          'Ridingtimes Z8 Pro', 'Ridingtimes GT54 Pro', 'Ridingtimes GT73 Pro',
          'Kaabo Mantis 10 Lite', 'Kaabo Mantis King GT', 'Kaabo King GTR Max',
          'Hiboy S2 Pro', 'Hiboy S2 Max', 'Hiboy TITAN Pro',
          'InMotion Challenger', 'KuKirin electric scooter',
          'Amflow e-bike', 'Surron e-bike'
        ];
        var whJobs = [
          'Packing an order for shipment',
          'Boxing up for an online order',
          'Palletizing new inventory for the shop floor',
          'Prepping a curbside pickup order',
          'Wrapping up for a Queens delivery rider',
          'Labeling for today\u2019s courier pickup',
          'Restocking the warehouse shelves'
        ];
        var whRand = seededRng(wsDayKey * 13 + 3 + Math.floor(nowMins / 5));
        var whRows = [];
        for(var wi = 0; wi < 6; wi++){
          var whProduct = wsPick(whRand, whProducts);
          var whJob = wsPick(whRand, whJobs);
          whRows.push('<div class="wq-ws-row"><span class="wq-ws-row-txt"><b>' + whProduct + '</b><small>' + whJob + '</small></span></div>');
        }
        if(prenoteEl){
          prenoteEl.hidden = false;
          prenoteEl.textContent = 'Today\u2019s repair drop-offs start when we open at ' + fmt12(hToday.open) + ' ET. Meanwhile, our Queens warehouse crew is already busy:';
        }
        var whAnimate = !reduce && whRows.length >= 4;
        var whHtml = whRows.join('');
        listEl.innerHTML = '<div class="wq-ws-scroll' + (whAnimate ? ' wq-ws-anim' : '') + '" style="--wq-ws-dur:' + Math.max(24, whRows.length * 4) + 's">' + whHtml + (whAnimate ? whHtml : '') + '</div>';
        return;
      } else {
        var tq = buildDayQueue(wsDayKey, hToday, 12);
        if(closed){
          /* after hours: past tense — most rides are picked up, a few are still on the rack */
          var tRand = seededRng(wsDayKey * 19 + 23);
          tq.slice().reverse().forEach(function(e){
            var picked = tRand() < 0.65;
            pushRow(e,
              picked ? { cls:'wq-ws-badge-done', txt:'Picked up' } : { cls:'wq-ws-badge-ready', txt:'Awaiting pickup' },
              'dropped off ' + fmt12(e.drop));
          });
        } else {
          /* live day. Early on, the board previews ahead so it's never thin — always ≥8 rows */
          var simNow = nowMins;
          var MIN_ROWS = 8;
          var sorted = tq.slice().sort(function(a, b){ return a.drop - b.drop; });
          if(sorted.length >= MIN_ROWS && sorted[MIN_ROWS - 1].drop > simNow){
            simNow = sorted[MIN_ROWS - 1].drop + 5;
          }
          var previewing = simNow > nowMins;
          var vis = tq.filter(function(e){ return e.drop <= simNow; }).slice().reverse();
          vis.forEach(function(e, k){
            /* previewing: walk newest→oldest through the whole flow so every status shows */
            var age = previewing ? (3 + k * 9) : Math.max(0, simNow - e.drop);
            pushRow(e, statusFor(age, e.drop), previewing ? ('dropped off ' + fmt12(e.drop)) : timeLabel(age, e.drop));
          });
        }
      }

      /* Vertical live ticker: duplicate the rows for a seamless top-to-bottom loop */
      var animate = !reduce && rows.length >= 4;
      var html = rows.join('');
      listEl.innerHTML = '<div class="wq-ws-scroll' + (animate ? ' wq-ws-anim' : '') + '" style="--wq-ws-dur:' + Math.max(24, rows.length * 4) + 's">'
        + html + (animate ? html : '') + '</div>';
    }

    function tabLabels(){
      var closed = etParts().hour * 60 + etParts().minute >= nyHoursToday().close;
      var lt = document.getElementById('wq-ws-tablabel-today');
      var ly = document.getElementById('wq-ws-tablabel-yday');
      if(lt) lt.textContent = closed ? 'Repaired today' : "Today's drop-offs";
      if(ly) ly.textContent = 'Repaired yesterday';
    }
    function setTab(tab){
      wsTab = tab;
      if(tabToday){ tabToday.classList.toggle('wq-ws-tab-on', tab === 'today'); tabToday.setAttribute('aria-selected', tab === 'today'); }
      if(tabYday){ tabYday.classList.toggle('wq-ws-tab-on', tab === 'yesterday'); tabYday.setAttribute('aria-selected', tab === 'yesterday'); }
      renderQueue();
    }
    if(tabToday) tabToday.addEventListener('click', function(){ setTab('today'); });
    if(tabYday)  tabYday.addEventListener('click', function(){ setTab('yesterday'); });

    /* ----- Four techs on the bench: no customer names, just the ride + the fix ----- */
    var techs = ['lin','jay','wil','sun'];
    var benchEls = {};
    techs.forEach(function(id){
      benchEls[id] = {
        job:   document.getElementById('wq-ws-job-'   + id),
        bar:   document.getElementById('wq-ws-bar-'   + id),
        stage: document.getElementById('wq-ws-stage-' + id),
        left:  document.getElementById('wq-ws-left-'  + id)
      };
    });
    /* Lin runs the front of house & the repair schedule — her card shows that work, not bench repairs */
    var linTasks = [
      { t:'Walking a rider through their quote \u2014 line by line', min:10 },
      { t:'Hunting down the right part for a repair',                min:15 },
      { t:'Slotting a walk-in into the repair schedule',             min:5  },
      { t:'Calling a rider \u2014 your ride is ready for pickup',   min:5  },
      { t:'Checking in a new drop-off at the front desk',            min:5  },
      { t:'Answering questions \u2014 nobody leaves without answers', min:10 }
    ];
    var linStages = ['Greeting\u2026','Listening\u2026','Explaining\u2026','Sorting it out\u2026','Wrapping up\u2026'];
    function newBenchJob(rand, id, avoidRides){
      if(id === 'lin'){
        var task = wsPick(rand, linTasks);
        return { title: task.t, dur: task.min, done: 0.12 + rand() * 0.55, front: true, picked: rand() < 0.7 };
      }
      var job = wsPick(rand, wsJobs);
      var pool = wsRidePools[wsCycle(wsDayKey)];
      var candidates = pool.filter(function(r){ return !avoidRides || avoidRides.indexOf(r) === -1; });
      if(!candidates.length) candidates = pool;
      var ride = wsPick(rand, candidates);
      return { title: ride + ' \u00b7 ' + job.t, ride: ride, dur: job.min, done: 0.12 + rand() * 0.55, picked: rand() < 0.7 };
    }
    var benchRand = seededRng(wsDayKey * 3 + etParts().hour * 17);
    var bench = {};
    var wsUsedRides = [];
    techs.forEach(function(id){
      bench[id] = newBenchJob(benchRand, id, wsUsedRides);
      if(bench[id].ride) wsUsedRides.push(bench[id].ride);
    });

    function paintBench(id, swap){
      var el = benchEls[id]; if(!el.job) return;
      var b = bench[id];
      var pct = Math.min(1, b.done);
      var left = Math.max(1, Math.round(b.dur * (1 - pct)));
      var stagePool = b.front ? linStages : wsStages;
      var stage = stagePool[Math.min(stagePool.length - 1, Math.floor(pct * stagePool.length))];
      function apply(){
        el.job.textContent = (!storeOpenNow && b.front) ? 'Wrapped for today' : b.title;
        if(el.bar) el.bar.style.width = Math.round(pct * 100) + '%';
        if(el.stage) el.stage.textContent = storeOpenNow ? stage : (b.front ? '' : 'Wrapped for today');
        if(el.left)  el.left.textContent  = storeOpenNow ? ('~' + left + ' min left') : (b.front ? '' : 'Picked up');
      }
      if(swap && !reduce){
        el.job.classList.add('wq-ws-fade');
        setTimeout(function(){ apply(); el.job.classList.remove('wq-ws-fade'); }, 300);
      } else { apply(); }
    }

    function tickBench(){
      techs.forEach(function(id){
        var b = bench[id];
        var swapped = false;
        if(storeOpenNow){
          b.done += (0.05 + Math.random() * 0.06);
          if(b.done >= 1){
            var avoid = techs.filter(function(t){ return t !== id; }).map(function(t){ return bench[t] && bench[t].ride; }).filter(Boolean);
            bench[id] = newBenchJob(benchRand, id, avoid);
            bench[id].done = 0.05;
            swapped = true;
          }
        } else {
          b.done = 1;
        }
        paintBench(id, swapped);
      });
    }

    /* ----- NYC weather in the board header ----- */
    function fetchHeaderWx(attempt){
      if(!boardWxEl) return;
      fetch('https://api.open-meteo.com/v1/forecast?latitude=40.74&longitude=-73.88&current=temperature_2m,weather_code&temperature_unit=fahrenheit&timezone=America%2FNew_York', { cache:'no-store' })
        .then(function(r){ return r.ok ? r.json() : Promise.reject(new Error('bad response')); })
        .then(function(data){
          var cur = data && data.current;
          if(!cur || typeof cur.temperature_2m !== 'number') return Promise.reject(new Error('no data'));
          var icons = {0:'\u2600\ufe0f',1:'\ud83c\udf24\ufe0f',2:'\u26c5',3:'\u2601\ufe0f',45:'\ud83c\udf2b\ufe0f',48:'\ud83c\udf2b\ufe0f',51:'\ud83c\udf26\ufe0f',53:'\ud83c\udf26\ufe0f',55:'\ud83c\udf27\ufe0f',61:'\ud83c\udf27\ufe0f',63:'\ud83c\udf27\ufe0f',65:'\ud83c\udf27\ufe0f',71:'\ud83c\udf28\ufe0f',73:'\ud83c\udf28\ufe0f',75:'\ud83c\udf28\ufe0f',80:'\ud83c\udf26\ufe0f',81:'\u26c8\ufe0f',82:'\u26c8\ufe0f',95:'\u26c8\ufe0f'};
          boardWxEl.innerHTML = '<span aria-hidden="true">' + (icons[cur.weather_code] || '\ud83c\udf2b\ufe0f') + '</span><b>' + Math.round(cur.temperature_2m) + '\u00b0F</b><span>Elmhurst weather</span>';
        })
        .catch(function(){
          if(attempt < 2){ setTimeout(function(){ fetchHeaderWx(attempt + 1); }, 4000); }
          else { boardWxEl.innerHTML = '<span aria-hidden="true">\ud83d\uddfd</span><b>Elmhurst</b><span>Queens, New York</span>'; }
        });
    }

    /* ----- Express next-slot line under the banner ----- */
    function renderNextSlot(){
      if(!nextSlotEl) return;
      /* Repairs completed today: deterministic daily target 14–23, climbs through store hours */
      var dayMax = 14 + Math.floor(seededRng(wsDayKey * 5 + 2)() * 10);
      var hh = nyHoursToday();
      var pp = etParts();
      var mnow = pp.hour * 60 + pp.minute;
      var prog = Math.max(0, Math.min(1, (mnow - hh.open) / (hh.close - hh.open)));
      var doneN = 14 + Math.round(prog * (dayMax - 14));
      if(liveFinalEl) liveFinalEl.textContent = doneN;
      var doneChip = '<span class="wq-ws-done"><b>' + doneN + '</b> repairs completed today</span> &middot; ';
      var r = computeRail();
      if(!r.slots.length){
        nextSlotEl.innerHTML = doneChip + 'express slots are fully booked today';
        return;
      }
      var when = (r.isToday ? 'today at ' : 'tomorrow at ') + fmt12(r.slots[0]) + ' ET';
      nextSlotEl.innerHTML = r.isToday
        ? (doneChip + 'next available slot <b>' + when + '</b>')
        : (doneChip + '\ud83c\udf19 today\u2019s booking is done. Next slot <b>' + when + '</b>');
    }

    /* ----- Boot ----- */
    function paintOnduty(){
      var heroSnapEl = document.getElementById('wq-hero-snap-cap');
      if(heroSnapEl) heroSnapEl.innerHTML = '<i aria-hidden="true"></i>Wilson\'s Queens';
      if(!ondutyEl) return;
      ondutyEl.classList.toggle('wq-ws-off', !storeOpenNow);
      if(storeOpenNow){ ondutyEl.innerHTML = '<i aria-hidden="true"></i>In the shop now'; }
      else {
        var pre = etParts().hour * 60 + etParts().minute < nyHoursToday().open;
        ondutyEl.innerHTML = '<i aria-hidden="true"></i>Back ' + (pre ? 'at ' + fmt12(nyHoursToday().open) : 'tomorrow at ' + fmt12(nyHoursToday().open));
      }
    }
    var benchLabels = {
      lin: { full:': Store Lead', closedLabel:': Front of house & Store Lead' },
      jay: { full:' is repairing', closedLabel:'\u2019s last repair' },
      wil: { full:' is repairing', closedLabel:'\u2019s last repair' },
      sun: { full:' is repairing',  closedLabel:'\u2019s last repair'  }
    };
    function paintBenchLabels(){
      Object.keys(benchLabels).forEach(function(id){
        var el = document.getElementById('wq-ws-benchlabel-' + id);
        if(!el) return;
        el.textContent = storeOpenNow ? benchLabels[id].full : benchLabels[id].closedLabel;
      });
    }
    paintOnduty();
    paintBenchLabels();
    tabLabels();
    setTab('today');
    tickBench();
    renderNextSlot();
    fetchHeaderWx(0);
    if(!reduce){
      setInterval(tickBench, 7000);
      setInterval(function(){ tabLabels(); renderQueue(); }, 60 * 1000);
      setInterval(renderNextSlot, 60 * 1000);
    }
    setInterval(function(){ fetchHeaderWx(0); }, 10 * 60 * 1000);
    /* refresh open/closed state without a reload if the page is left open across opening time */
    setInterval(function(){
      var open = isStoreOpenNow();
      if(open !== storeOpenNow){
        storeOpenNow = open;
        paintOnduty();
        paintBenchLabels();
        tabLabels(); tickBench(); renderQueue(); renderNextSlot();
      }
    }, 60 * 1000);
  })();

  /* Hero showcase card is now static — no picker JS needed */

  /* ---------- Open/closed status on the Queens location card ---------- */
  var locCard = document.getElementById('loc-qn');
  if(locCard){
    var statusEl = locCard.querySelector('.wq-loc-status');
    if(statusEl){
      var openNow = isStoreOpenNow();
      statusEl.textContent = openNow ? 'Open now' : 'Closed now';
      statusEl.classList.add(openNow ? 'wq-open' : 'wq-closed');
    }
  }

  /* ---------- Repair guide tabs ---------- */
  var guideRoot = document.getElementById('wq-guide');
  if(guideRoot){
    var guideTabs = guideRoot.querySelectorAll('.wq-guide-tab');
    var guidePanels = guideRoot.querySelectorAll('.wq-guide-panel');
    guideRoot.classList.add('wq-guide-ready');

    function activateGuide(key){
      guideTabs.forEach(function(t){
        var on = t.dataset.guide === key;
        t.classList.toggle('wq-guide-tab-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      guidePanels.forEach(function(p){
        p.classList.toggle('wq-guide-panel-active', p.dataset.guidePanel === key);
      });
    }
    guideTabs.forEach(function(tab, i){
      tab.addEventListener('click', function(){ activateGuide(tab.dataset.guide); });
      tab.addEventListener('keydown', function(e){
        if(e.key !== 'ArrowDown' && e.key !== 'ArrowUp' && e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        var dir = (e.key === 'ArrowDown' || e.key === 'ArrowRight') ? 1 : -1;
        var next = guideTabs[(i + dir + guideTabs.length) % guideTabs.length];
        next.focus();
        activateGuide(next.dataset.guide);
      });
    });
  }

  /* ---------- Google Business Profile panel: live open status + star pop ---------- */
  (function(){
    var starsEl = document.getElementById('wq-google-stars');
    if(starsEl){
      var chars = starsEl.textContent.trim().split('');
      starsEl.innerHTML = chars.map(function(ch){ return '<span>' + ch + '</span>'; }).join('');
      if('IntersectionObserver' in window){
        var sio = new IntersectionObserver(function(entries){
          entries.forEach(function(en){
            if(en.isIntersecting){ starsEl.classList.add('wq-stars-in'); sio.unobserve(en.target); }
          });
        }, { threshold:.6 });
        sio.observe(starsEl);
      } else { starsEl.classList.add('wq-stars-in'); }
    }
  })();

  /* ---------- GBP rating badge: star fill on scroll ---------- */
  (function(){
    var scoreEl = document.getElementById('wq-gbp-score');
    if(!scoreEl) return;
    if('IntersectionObserver' in window){
      var gio = new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          if(en.isIntersecting){ scoreEl.classList.add('wq-gr-in'); gio.unobserve(en.target); }
        });
      }, { threshold:.5 });
      gio.observe(scoreEl);
    } else { scoreEl.classList.add('wq-gr-in'); }
  })();

  /* ---------- FAQ search + category filter ---------- */
  var faqList = document.getElementById('wq-faq-list');
  if(faqList){
    var faqItems = faqList.querySelectorAll('details');
    var faqChips = root.querySelectorAll('.wq-faq-chip');
    var faqSearch = document.getElementById('wq-faq-search');
    var faqCountEl = document.getElementById('wq-faq-count');
    var faqEmptyEl = document.getElementById('wq-faq-empty');
    var activeCat = 'all';

    function faqApply(){
      var q = (faqSearch && faqSearch.value || '').trim().toLowerCase();
      var shown = 0;
      faqItems.forEach(function(item){
        var matchesCat = activeCat === 'all' || item.dataset.cat === activeCat;
        var text = item.textContent.toLowerCase();
        var matchesQuery = !q || text.indexOf(q) > -1;
        var visible = matchesCat && matchesQuery;
        item.classList.toggle('wq-faq-hide', !visible);
        if(visible) shown++;
      });
      if(faqCountEl) faqCountEl.textContent = shown + (shown === 1 ? ' question' : ' questions') + (activeCat !== 'all' || q ? ' match' + (shown===1?'es':'') : ' shown');
      if(faqEmptyEl) faqEmptyEl.hidden = shown !== 0;
    }
    faqChips.forEach(function(chip){
      chip.addEventListener('click', function(){
        faqChips.forEach(function(c){ c.classList.remove('wq-faq-chip-active'); });
        chip.classList.add('wq-faq-chip-active');
        activeCat = chip.dataset.cat;
        faqApply();
      });
    });
    if(faqSearch) faqSearch.addEventListener('input', faqApply);
    faqApply();
  }

})();
